// extracted by mini-css-extract-plugin
export default {"duration":"baseForm_duration__YhCyu","budgets":"baseForm_budgets__-kHu4"};